import { Build, Step, StepDependencyContext } from "~/components/build/Show/lib/types";
import fetcher from "~/components/build/Show/lib/fetcher";
import { queryOptions, UseQueryOptions } from "@tanstack/react-query";

type stepDependenciesResponse = Record<Step["uuid"], StepDependencyContext>;

export function stepDependenciesQueryKey(buildId: Build["id"], stepUploadsCount: number) {
  return ["build", buildId, "step-dependencies", stepUploadsCount];
}

export function stepDependenciesQueryOptions(
  build: Build,
  stepUploadsCount: number,
  queryOptionArgs: Omit<UseQueryOptions<stepDependenciesResponse>, "queryKey" | "queryFn"> = {},
) {
  if (!build) {
    throw new Error("build is required");
  }

  const options: UseQueryOptions<stepDependenciesResponse> = {
    queryKey: stepDependenciesQueryKey(build.id, stepUploadsCount),
    queryFn: () => fetchstepDependencies(build),
    ...queryOptionArgs,
  };

  return queryOptions(options);
}

async function fetchstepDependencies(build: Build): Promise<stepDependenciesResponse> {
  const url = `${build.buildDataBasePath}/step-dependencies`;

  // We don't want to use the Database.parser method here as it will camelize stepUUID keys.
  return fetcher<stepDependenciesResponse>(url, false);
}
